import { render, staticRenderFns } from "./ticket-category-manage.vue?vue&type=template&id=46822a56&scoped=true"
import script from "./ticket-category-manage.vue?vue&type=script&lang=js"
export * from "./ticket-category-manage.vue?vue&type=script&lang=js"
import style0 from "./ticket-category-manage.vue?vue&type=style&index=0&id=46822a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46822a56",
  null
  
)

export default component.exports